import ApiService from './api.service';
const PREFIX = 'warehouse-document';
const FROM_SALE_PREFIX = 'sale-transaction';

const WhIncomeService = {
	/**
	 * INCOMES FROM SALE
	 */
	addNotFoundItemsToDatabase(newItems) {
		return ApiService.post(`${FROM_SALE_PREFIX}/add-not-found-items`, newItems);
	},
	getTCountOfDocsFromSale() {
		return ApiService.get(`${FROM_SALE_PREFIX}/pending-count`);
	},
	receivePendingIncomeFromSale(depIdAndPayload) {
		return ApiService.post(
			`${FROM_SALE_PREFIX}/receive-sale/${depIdAndPayload.depId}`,
			depIdAndPayload.payload
		);
	},
	fetchPendingIncomeFromSaleById(docId) {
		return ApiService.get(`${FROM_SALE_PREFIX}/get-by-id/${docId}`);
	},
	fetchPendingIncomesFromSale(payload) {
		return ApiService.post(`${FROM_SALE_PREFIX}/pending-list`, payload);
	},
	pendingCount: () => {
		return ApiService.get(`${PREFIX}/pending-documents-count`);
	},

	/** INCOMES FROM MANUFACTURE **/
	getPendingIncomesFromManufactureApi(payload) {
		let config = {
			method: 'POST',
			url: 'http://213.230.127.153:9000/api/v1/products/pack',
			baseURL: '/',
			data: payload
		};
		return ApiService.customRequest(config);
	},
	getPackList(payload) {
		let config = {
			method: 'POST',
			url: 'http://213.230.127.153:9000/api/v1/products/list',
			baseURL: '/',
			data: payload
		};
		return ApiService.customRequest(config);
	},
	/* RECEIVE PENDING INCOME ITEMS */
	receivePendingIncome(payload) {
		return ApiService.post(`${PREFIX}/receive-pending-doc`, payload);
	},
	/* CHECK PENDING INCOME ITEMS */
	checkPendingIncomeItems(payload) {
		return ApiService.post(`${PREFIX}/check-pending-doc`, payload);
	},
	acceptByManufacturer(payload) {
		let config = {
			method: 'POST',
			url: 'http://213.230.127.153:9000/api/v1/products/accepted',
			baseURL: '/',
			data: payload
		};
		return ApiService.customRequest(config);
	},
	getPendingIncomesCountService(payload) {
		let config = {
			method: 'POST',
			url: 'http://213.230.127.153:9000/api/v1/products/total-pack',
			baseURL: '/',
			data: payload
		};
		return ApiService.customRequest(config);
	}
};

export default WhIncomeService;
